/* eslint-disable camelcase */
class Focus implements MerchantosFocus {
  recorded: boolean | string;

  constructor() {
    this.recorded = false;
  }

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
  // eslint-disable-next-line no-return-assign
  record = id => (this.recorded = id);

  restore = () => {
    if (!this.recorded) {
      return false;
    }

    const res = this.set($(`#${this.recorded}`)[0]);
    this.recorded = false;
    return res;
  };

  // @ts-expect-error ts-migrate(2416) FIXME: Property 'set' in type 'Focus' is not assignable t... Remove this comment to see the full error message
  set = (element: HTMLElement | JQuery<HTMLElement>) => {
    if (window.isMobileDevice() || !element) {
      return;
    }

    if (!(element instanceof jQuery)) {
      if (typeof element === 'string') {
        // eslint-disable-next-line no-param-reassign
        element = $(`#${element}`);
      } else if (element instanceof HTMLElement) {
        // eslint-disable-next-line no-param-reassign
        element = $(element);
      } else {
        return;
      }
    }

    (element as JQuery<HTMLElement>).trigger('focus').trigger('select');
  };
}

// @ts-expect-error ts-migrate(2322) FIXME: Type 'Focus' is not assignable to type 'Merchantos... Remove this comment to see the full error message
window.merchantos.focus = new Focus();

window.setFocusOnId = function setFocusOnId(ele) {
  return window.merchantos.focus.set(ele);
};

window.setFocus = function setFocus(ele) {
  return window.merchantos.focus.set(ele);
};

window.setAutoFocus = function setAutoFocus(parent_ele) {
  if (parent_ele) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement | JQuery<HTMLElement... Remove this comment to see the full error message
    // eslint-disable-next-line no-param-reassign
    parent_ele = window.xGetElementById(parent_ele);

    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    if ($(parent_ele).find('.priority_auto_focus').length > 0) {
      window.setFocus(
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        $(parent_ele)
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'find' does not exist on type 'JQueryStat... Remove this comment to see the full error message
          .find('.priority_auto_focus')
          .first()
      );
      return;
    }

    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    $(parent_ele)
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'find' does not exist on type 'JQueryStat... Remove this comment to see the full error message
      .find('.set_auto_focus')
      .each(function autoFocusElements() {
        // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        if ($(this).find('.data_control').length > 0) {
          // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
          window.setFocus($(this).find('.data_control')[0]);
        }
      });
  } else {
    if ($('.priority_auto_focus').length > 0) {
      window.setFocus($('.priority_auto_focus').first());
      return;
    }

    $('.set_auto_focus').each(function autoFocusElements() {
      if ($(this).find('.data_control').length > 0) {
        window.setFocus($(this).find('.data_control')[0]);
      }
    });
  }
};

// SetTimeout is needed because (I think) the click handler runs after the focus
// handler and that wipes out a selection of text that was selected during the
// focus code. Mainly due to the event loop: https://stackoverflow.com/a/779785
window.selectField = function selectField(field) {
  if (field) {
    // eslint-disable-next-line no-param-reassign
    field.oldValue = field.value;
    if (window.isMobileDevice()) {
      if (window.supportsSelectionRange(field)) {
        // type number is supported on iPads but not on Android tablets so if the
        // .setSelectionRange fails the .select will succeed on Android
        try {
          field.setSelectionRange(0, field.value.length);
        } catch (err) {
          if (err instanceof DOMException && err.name === 'InvalidStateError') {
            field.select();
          } else {
            throw err;
          }
        }
      }
    } else {
      setTimeout(() => {
        field.select();
      }, 0);
    }
  }
};

// Returns whether the given HTMLInputElement supports the setSelectionRange
// According to the spec only text, search, URL, tel and password type inputs support it.
// Otherwise it throws an InvalidStateError
// https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
// https://html.spec.whatwg.org/multipage/forms.html#concept-input-apply
// @ts-expect-error ts-migrate(2322) FIXME: Type '(input: HTMLInputElement) => boolean | ""' i... Remove this comment to see the full error message
window.supportsSelectionRange = function supportsSelectionRange(input) {
  // @ts-expect-error ts-migrate(2774) FIXME: This condition will always return true since the f... Remove this comment to see the full error message
  if (input && input.setSelectionRange) {
    return (
      input.type &&
      (input.type === 'text' ||
        input.type === 'number' ||
        input.type === 'email' ||
        input.type === 'search' ||
        input.type === 'url' ||
        input.type === 'tel' ||
        input.type === 'password')
    );
  }
  return false;
};

window.onFocusSelect = function onFocusSelect(field) {
  return window.selectField(field);
};
